import React, { useCallback } from 'react';
import { useAlteracaoIbsCbsLote } from '../../hooks/useAlteracaoIbsCbsLote';
import { Button } from '../../styles';
import ToggleDefault from '~/components/ToggleDefault';
import { Col, Row } from 'react-bootstrap';
import Loja from '~/components/Loja';
import Separator from '~/components/Separator';
import { BuscaProduto } from '~/components/NovosInputs';
import { nanoid } from 'nanoid';
import { toast } from 'react-toastify';
import { rowProps } from '../../types';

export const Form: React.FC = () => {
  const {
    formAlteracaoIbsCbs: {
      register,
      control,
      formState: { errors },
      setValue,
    },
    lojas,
    handleChangeLojas,
    flgSemIbsCbs,
    setFlgSemIbsCbs,
    setLoadingTable,
    rows,
    setRows,
    handleCheckAllProducts,
    resetCampo,
    setResetCampo,
  } = useAlteracaoIbsCbsLote();

  const handleFocusBuscaProduto = useCallback(() => {
    const buscaProduto = document.getElementsByName('busca_produto');
    if (buscaProduto.length > 0) {
      setTimeout(() => {
        buscaProduto[0].click();
        buscaProduto[0].focus();
      }, 100);
    }
  }, []);

  const handleAddProduto = useCallback(
    (selected: any) => {
      let exists = 0;
      rows.map((produto: rowProps) => {
        const produtoExist = selected.some(
          (p: rowProps) => p.cod_produto === produto.cod_produto,
        );
        if (produtoExist) {
          exists++;
        }
        return produto;
      });

      if (exists > 0) {
        setLoadingTable(false);
        handleFocusBuscaProduto();
        return toast.warning(`Produto já adicionado na grade`);
      }
      const produtoInsert = selected
        .filter((i: rowProps) => !flgSemIbsCbs || i.cod_ibs_cbs === null)
        .map((i: rowProps) => {
          return {
            uuid: nanoid(),
            cod_loja: i.cod_loja,
            cod_produto: i.cod_produto,
            des_produto: i.des_produto,
            des_ibs_cbs: i.des_ibs_cbs,
            des_classif_trib: i.des_classif_trib,
            flg_transfer: true,
          };
        });
      if (produtoInsert.length <= 0) {
        toast.warn(
          'Produto(s) selecionado(s) já possuem uma classificação IBS/CBS vinculada',
        );
      }
      setLoadingTable(true);
      setRows((prev) => [...prev, ...produtoInsert]);
      handleFocusBuscaProduto();
      setTimeout(() => {
        setLoadingTable(false);
      }, 50);
    },
    [flgSemIbsCbs, rows, setRows],
  );

  return (
    <>
      <Row>
        <Col sm={12} md={9}>
          <Loja
            isMulti
            onChange={(val: number | number[]) => {
              handleChangeLojas(val);
            }}
            disabled={false}
            selectedLoja={lojas}
          />
        </Col>
        <Col sm={12} md={3} style={{ marginTop: '13px' }}>
          <ToggleDefault
            labelText="Somente produtos sem IBS/CBS"
            inLine
            setChecked={flgSemIbsCbs}
            onSwitch={() => setFlgSemIbsCbs(!flgSemIbsCbs)}
          />
        </Col>
      </Row>
      <Col sm={12} md={12}>
        <Separator labelText="Busca Por" />
      </Col>
      <Row>
        <Col sm={12} md={12} style={{ marginTop: '-15px' }}>
          <BuscaProduto
            placeholder="Busque por Código, GTIN ou Descrição *"
            name="busca_produto"
            register={register}
            isError={!!errors.busca_produto}
            control={control}
            buscaNasLojas={lojas || 1}
            customOptions={{
              buscarPor: [
                'Produto',
                'Fornecedor',
                'Departamento',
                'NCM',
                'Check-List',
              ],
              showSelecionarItensContendo: true,
              buscaPadrao: 'Produto',
              onlyIbsCbsNull: flgSemIbsCbs,
            }}
            setValue={setValue}
            clearCampoBusca={resetCampo}
            getProduct={(selected: any) => {
              handleAddProduto(selected);
              setResetCampo(false);
            }}
          />
        </Col>
        <Col sm={12} md={12}>
          <Separator childrenWidth="270px">
            <div style={{ display: 'flex' }}>
              <Button
                type="button"
                style={{
                  marginTop: '-7px',
                }}
                onClick={() => {
                  handleCheckAllProducts(false);
                }}
              >
                Desmarcar Todas
              </Button>{' '}
              |
              <Button
                type="button"
                style={{
                  marginTop: '-7px',
                }}
                onClick={() => {
                  handleCheckAllProducts(true);
                }}
              >
                Marcar Todas
              </Button>
            </div>
          </Separator>
        </Col>
      </Row>
    </>
  );
};
